import request from '@/utils/request';
import router from '@/router';

/* eslint-disable */
const actions = {
  async addGroup({ dispatch, commit }, set) {
    try {
      const { data } = await request.post('groups', set);

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      router.push({ name: "products.edit", params: { uuid: data.group.uuid } });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
